import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1DrawerLinkStyles: moduleStyleType = {
    link: {
        overflow: 'hidden',
        cursor: 'pointer',
        display: 'inline-flex',

        '&:hover': {
            color: palette.primary.extraDark,
        },
    },
    dashedVariant: {
        textDecoration: 'underline dashed',
        textUnderlineOffset: '0.2em',

        '&:hover': {
            textDecoration: 'underline dashed',
            color: palette.primary.extraDark,
            backgroundColor: palette.primary.extraLight,
        },
    },
}

export const styles: moduleStyleType = {
    link: {
        display: 'inline-flex',
        '&.MuiLink-underlineHover:hover': {
            textDecoration: 'none',
        },
    },
    label: {
        maxWidth: '28ch',
        borderBottom: `1px dashed ${palette.primary.main}`,
        cursor: 'pointer',
        '&:hover': {
            color: palette.primary.extraDark,
            borderBottom: `1px dashed ${palette.primary.extraDark}`,
            backgroundColor: palette.primary.extraLight,
        },
    },
}
